import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    /* font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif !important; */
    font-family: 'Roboto' !important;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    /* font-family: 'Roboto', Georgia, Times, 'Times New Roman', serif !important; */
    font-family: 'Roboto' !important;
    line-height: 1.5em;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }

  ol {
    list-style-type: decimal !important;
    list-style-position: inside !important;
    -webkit-margin-before: 1em !important;
    -webkit-margin-after: 1em !important;
    -webkit-margin-start: 0px !important;
    -webkit-margin-end: 0px !important;
    -webkit-padding-start: 0px !important;
  }
`;
